// extracted by mini-css-extract-plugin
export default {"spinner":"LoadingSpinner_spinner__jmu8Z","spin":"LoadingSpinner_spin__YPWy1"};